<template>
  <div class="bg-danger text-white text-center py-3" style="font-size: 1.3em;" v-if="show">
    Restauracja jest nieczynna. Zapraszamy ponownie od 14 kwietnia.
  </div>
</template>
<script>
export default {
  name: 'ImportantInfo',
  data: () => ({
    show: new Date() < new Date(2023, 3, 14)
  })
}
</script>
